export default __webpack_public_path__ + "static/dxtecalis-e0ec0046dde90b76697d9822d693c5d0.jpg";